import {CSVLink} from 'react-csv';
import {PropsWithChildren, useMemo} from 'react';
import {getDataForExport, ObjectCostRateModelEntity, PipelineFlowTransportEntity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {ExportLinkProps} from "../ExportLink/ExportLink";

type Props = ExportLinkProps<PipelineFlowTransportEntity>

export function PipelineFlowTransportExportLink(props: PropsWithChildren<Props>) {
  const {filePrefix, data, children} = props;

  const {t} = useTranslation(["common"])

  const rateModels = useMemo(() => {
    if (data) {
      const ocrms = data.reduce((prev, curr) => {
        if (curr.objectCostRateModels) {
          prev.push(...curr.objectCostRateModels)
        }
        return prev
      }, [] as ObjectCostRateModelEntity[])

      return new Map(ocrms.map((ocrm) => [ocrm.rateModelId, ocrm.rateModelName ?? "Unknown"]))
    }

    return undefined
  }, [data])

  const headers = useMemo(() => {
    if (data && data.length > 0) {

      const csvHeader = [...data[0].CSV_HEADERS]

      rateModels?.forEach((value, key) => {
        csvHeader.push(value + " Cost")
      })

      return csvHeader;
    }

    return undefined

  }, [data, rateModels]);

  const exportData = useMemo(() => {
    if (data) {
      return getDataForExport(data, (e, row) => {
        rateModels?.forEach((value, key) => {
          const ocrm = e.getObjectCostRateModelById(key)
          row.push(ocrm?.totalCost?.toString() ?? "0")
        })
      })
    }

    return undefined
  }, [data, rateModels]);

  const exportFileName = useMemo(() => {
    let prefix = '';
    if (filePrefix) {
      prefix = filePrefix + '_';
    }

    return prefix + new Date().getTime() + '_export.csv';
  }, [filePrefix]);

  if (exportData && exportData.length > 0) {
    return (
      <CSVLink style={{textDecoration: "none"}} headers={headers} data={exportData} filename={exportFileName}>
        {children ? children : t("common.action.export", "Export")}
      </CSVLink>
    );
  }

  return null;
}
